/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Permissions_CreatedInputs */

const en_admin_permissions_created = /** @type {(inputs: Admin_Permissions_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permission created`)
};

const zh_admin_permissions_created = /** @type {(inputs: Admin_Permissions_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`权限已创建`)
};

/**
* | output |
* | --- |
* | "Permission created" |
*
* @param {Admin_Permissions_CreatedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_permissions_created = /** @type {((inputs?: Admin_Permissions_CreatedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Permissions_CreatedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_permissions_created(inputs)
	return zh_admin_permissions_created(inputs)
});
export { admin_permissions_created as "admin.permissions.created" }